"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEEKNUM = void 0;
exports.WEEKNUM = {
    alias: 'NUMSEMANA',
    description: 'Retorna o número da semana no ano de uma data',
    arg_names: ['data'],
    args_description: ['data para extrair o número da semana'],
    target_date_format: 'dd/MM/yyyy',
    source_date_format: 'yyyy-MM-dd',
};
